import type { ICustomAlertPreference } from '../types/api-caller';

export const compareCustomAlertsByName = (a: ICustomAlertPreference, b: ICustomAlertPreference): number => {
  const nameComparison = (a.name ?? '').localeCompare(b.name ?? '', undefined, { sensitivity: 'base' });
  if (nameComparison !== 0) return nameComparison;

  return (a.alert_id ?? 0) - (b.alert_id ?? 0);
};

export const sortCustomAlertsByName = (alerts: ICustomAlertPreference[]): ICustomAlertPreference[] => {
  return [...alerts].sort(compareCustomAlertsByName);
};
